import "./config";
////config IndexedDB Begin/////////
export const DB_NAME = "myAppDB"; ///db_name
export const DB_VERSION = 1; ///version db

///// Danh sách store (bảng) cần tạo ánh xạ từ csdl
export const STORE_NAMES = {
    tbl_cate_ethnic: "tbl_cate_ethnic",
    tbl_cate_forms_training: "tbl_cate_forms_training",
    tbl_cate_informatics_certificate: "tbl_cate_informatics_certificate",
    tbl_cate_language_certificate: "tbl_cate_language_certificate",
    tbl_cate_nationality: "tbl_cate_nationality",
    tbl_cate_organize: "tbl_cate_organize",
    tbl_cate_position_party: "tbl_cate_position_party",
    tbl_cate_position_trade_union: "tbl_cate_position_trade_union",
    tbl_cate_position_union: "tbl_cate_position_union",
    tbl_cate_religion: "tbl_cate_religion",
    tbl_diary_personal: "tbl_diary_personal",
    tbl_function_permission: "tbl_function_permission",
    tbl_menu: "tbl_menu",
    tbl_module_permission: "tbl_module_permission",
    tbl_organize: "tbl_organize",
    tbl_organize_info: "tbl_organize_info",
    tbl_product: "tbl_product",
    tbl_product_cate: "tbl_product_cate",
    tbl_role: "tbl_role",
    tbl_session_user: "tbl_session_user",
    tbl_staff: "tbl_staff",
    tbl_user: "tbl_user",
    tbl_work_day: "tbl_work_day",
    tbl_work_schedule: "tbl_work_schedule",
    tbl_work_task: "tbl_work_task",
    my_function_permission: "my_function_permission",
    dashboards: "dashboards",
    sync_tracking: "sync_tracking", /////theo doi dong bo
};

window.DB_NAME = DB_NAME;
window.DB_VERSION = DB_VERSION;
window.STORE_NAMES = STORE_NAMES;
////////////////config IndexedDB End////////////
